const apiCall = async service => {
	const res = await service
	return res.data
}

export default apiCall
